<template>
  <FormFilter
    v-model="filterData"
    @request="onSubmit"
    @reset="onReset"
  >
    <AppInputDate
      title="Дата изменений"
      name="created_at"
      type="single"
    />

    <VSelect
      label="По ответственному"
      name="user"
      :items="userList"
      :handler-search="GETUserList"
      search
    />

    <VSelect
      label="Объект изменения"
      name="loggable_object"
      :items="changelogObjectList"
      search
    />
  </FormFilter>
</template>

<script>
import AppInputDate from '@/components/page/input/AppInputDate'
import FormFilter from '@/components/page/Form/FormFilter/FormFilter'
import VSelect from '@/components/page/Form/VSelect'

import { MIXIN_FORM_FILTER } from '@/mixins/form/mixinFormFilter'
import { MIXIN_USER_LIST } from '@/mixins/handbook/userList'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'FilterPtoChangelog',
  components: {
    AppInputDate,
    FormFilter,
    VSelect
  },
  mixins: [
    MIXIN_FORM_FILTER,
    MIXIN_USER_LIST
  ],
  data () {
    return {
      filterData: {}
    }
  },
  async mounted () {
    this.filterData = this.filterValue
  },
  computed: {
    ...mapState('handbook/pto', {
      changelogObjectList: 'changelogObjectList'
    }),
    ...mapGetters('pto/changelog', {
      filterValue: 'getFilterValue'
    }),

    userListFiltered () {
      const validRoles = ['administrator', 'pto_full']

      return this.userList.filter(user => {
        if (!user?.roles?.length) return false

        for (const role of user.roles) {
          if (validRoles.includes(role.slug)) {
            return true
          }
        }

        return false
      })
    }
  },
  methods: {
    onSubmit (data) {
      this.$emit('request', data)
    }
  }
}
</script>
